import { mediaType as MediaType } from '@bt-react/constants'
import { SyncUIReducer } from './types'
import { LayoutType } from '../../../slices/layouts/layoutsSlice'

export const syncUIDefaultReducerState: SyncUIReducer = {
  endingLive: false,
  focusOn: null,
  screenShareFocus: null,
  gigTerminationTime: '',
  goingLive: false,
  mute: [],
  playInMute: [],
  liveDateTime: null,
  liveEnded: false,
  mediaType: MediaType.WEBCAM,
  participantInformation: [],
  presenterCount: 0,
  videoDisplay: [],
  slidePosition: {
    selectedSlideStep: 0,
    selectedSlide: 0
  },
  pendingSlidesId: null,
  autoSpotlight: false,
  dominantSpeaker: null,
  eventStreamUrl: '',
  layouts: {
    presenterLayout: {
      presenterLayoutsActive: false,
      sidebarActive: false,
      layoutType: LayoutType.Full,
    },
    mediaLayout: {
      mediaSidebarActive: false,
      mediaLayoutType: LayoutType.Full
    }
  },
  conversationCreatorId: '',
  conversationName: '',
  questions: {
    c: '',
    s: false,
    a: false
  }
}

export default syncUIDefaultReducerState
